"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _service = require("./service");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _PublicTagModals = require("./PublicTagModals");

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getTagWithHighestCount(tagsToMerge) {
  if (tagsToMerge.length === 0) {
    return '';
  }

  var tag = tagsToMerge.reduce(function (previousTag, currentTag) {
    return previousTag.count > currentTag.count ? previousTag : currentTag;
  }, tagsToMerge[0]);
  return tag.name;
}

function filterOutDuplicateTags(tagsToMerge, mergedTag) {
  return tagsToMerge.filter(function (tag) {
    return tag.id !== mergedTag.id;
  });
}

function filterOutMergedTags(tags, mergedTags) {
  return tags.filter(function (d) {
    return !mergedTags.includes(d);
  });
}

function getIsNewTagCreated(updatedTags, mergedTag) {
  return updatedTags.filter(function (tag) {
    return tag.name === mergedTag.name;
  }).length === 0;
}

function deselectTags(updatedTags) {
  updatedTags.forEach(function (t) {
    t.selected = false;
  });
}

function getTagFromResponse(tagResponse) {
  return {
    id: tagResponse.id,
    name: tagResponse.name,
    count: 'recalculation in progress...',
    selected: false
  };
}

function getNewTotal(mergedTagsLength, isNewTagCreated, total) {
  if (!total) {
    return undefined;
  }

  var newTotal = total - mergedTagsLength;

  if (isNewTagCreated) {
    newTotal = newTotal - 1;
  }

  return newTotal;
}

var MergePublicsTag = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MergePublicsTag, _Component);

  var _super = _createSuper(MergePublicsTag);

  function MergePublicsTag() {
    var _this;

    (0, _classCallCheck2.default)(this, MergePublicsTag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      modalErrorMessage: undefined,
      showMergeModal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMergeModal", function () {
      _this.setState({
        showMergeModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCloseModal", function () {
      _this.setState({
        showMergeModal: false,
        modalErrorMessage: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickModalInput", function () {
      _this.setState({
        modalErrorMessage: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mergeTags", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(newName) {
        var _this$props, _this$props$paginatio, page, pageSize, total, setAlertMessage, setIsLoading, setTagsAndPagination, tagIndex, tags, tagsToMerge, tagIdsToMerge, data, mergedTag, mergedTags, updatedTags, isNewTagCreated, currentPage, _ref2, hits, newPagination, _err$response, _err$response$data, errorMessage;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, _this$props$paginatio = _this$props.pagination, page = _this$props$paginatio.page, pageSize = _this$props$paginatio.pageSize, total = _this$props$paginatio.total, setAlertMessage = _this$props.setAlertMessage, setIsLoading = _this$props.setIsLoading, setTagsAndPagination = _this$props.setTagsAndPagination, tagIndex = _this$props.tagIndex, tags = _this$props.tags, tagsToMerge = _this$props.tagsToMerge;
                setIsLoading(true);

                if (newName) {
                  _context.next = 6;
                  break;
                }

                _this.setState({
                  modalErrorMessage: 'Please enter tag name'
                });

                setIsLoading(false);
                return _context.abrupt("return");

              case 6:
                tagIdsToMerge = tagsToMerge.map(function (t) {
                  return t.id;
                });
                _context.prev = 7;
                _context.next = 10;
                return (0, _service.mergeTags)(newName, tagIdsToMerge);

              case 10:
                data = _context.sent;
                mergedTag = getTagFromResponse(data);
                mergedTags = filterOutDuplicateTags(tagsToMerge, mergedTag);
                updatedTags = filterOutMergedTags(tags, mergedTags);
                isNewTagCreated = getIsNewTagCreated(updatedTags, mergedTag);

                if (isNewTagCreated) {
                  updatedTags.push(mergedTag);
                }

                deselectTags(updatedTags);
                currentPage = page !== null && page !== void 0 ? page : _utils.DEFAULT_PAGE;

                if (!(total && pageSize && total > pageSize)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 21;
                return tagIndex.getFirstRecordsFromNextPage(currentPage, pageSize, mergedTags.length);

              case 21:
                _ref2 = _context.sent;
                hits = _ref2.hits;
                updatedTags.push.apply(updatedTags, (0, _toConsumableArray2.default)(hits));

              case 24:
                newPagination = {
                  page: currentPage,
                  pageSize: pageSize,
                  total: getNewTotal(mergedTags.length, isNewTagCreated, total)
                };
                setTagsAndPagination(updatedTags, newPagination);
                setAlertMessage("".concat(mergedTags.length, " public tags have been merged to '").concat(mergedTag.name, "'!"), 'success');
                setIsLoading(false);
                tagIndex.clearCache();
                _context.next = 36;
                break;

              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](7);
                errorMessage = ((_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors) || _utils.DEFAULT_ERROR_MESSAGE;

                _this.setState({
                  modalErrorMessage: errorMessage
                });

                setAlertMessage('', null);

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 31]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(MergePublicsTag, [{
    key: "render",
    value: function render() {
      var tagsToMerge = this.props.tagsToMerge;
      var _this$state = this.state,
          modalErrorMessage = _this$state.modalErrorMessage,
          showMergeModal = _this$state.showMergeModal;
      var tagWithHighestCount = getTagWithHighestCount(tagsToMerge);
      return (0, _preact.h)("div", null, (0, _preact.h)(_Button.default, {
        className: "qa-merge-public-tag",
        variant: "brand",
        title: "Merge tags",
        onClick: this.showMergeModal
      }), showMergeModal && (0, _preact.h)(_PublicTagModals.MergeModal, {
        onClose: this.onCloseModal,
        tag: tagWithHighestCount,
        onClick: this.onClickModalInput,
        onSave: this.mergeTags,
        mergeCount: tagsToMerge.length,
        error: modalErrorMessage
      }));
    }
  }]);
  return MergePublicsTag;
}(_preact.Component);

var _default = MergePublicsTag;
exports.default = _default;